var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.is,{tag:"component",class:{
    'dp-dropdown-separator': _vm.isSeparator,
    'dp-dropdown-item': !_vm.isSeparator,
    'dp-dropdown-item--delete': _vm.isDelete,
    'dp-dropdown-item--disabled': _vm.disabled,
  },attrs:{"to":_vm.to,"href":""},on:{"click":function($event){$event.preventDefault();return _vm.handleClick.apply(null, arguments)}}},[(_vm.icon)?_c('dp-icon',{attrs:{"name":_vm.icon}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }